// extracted by mini-css-extract-plugin
export var actions = "_dk-g";
export var benefitCard = "_dk-b";
export var benefitIcon = "_dk-d";
export var benefitLabel = "_dk-f";
export var benefits = "_dk-a";
export var benefitsSection = "_dk-8";
export var bodyText = "_dk-7";
export var closeButton = "_dk-2";
export var content = "_dk-3";
export var eyebrow = "_dk-4";
export var heading = "_dk-5";
export var image = "_dk-i";
export var imagePanel = "_dk-h";
export var modal = "_dk-0";
export var offerCard = "_dk-c";
export var offerIcon = "_dk-e";
export var sectionLabel = "_dk-9";
export var shell = "_dk-1";
export var title = "_dk-6";